import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Define the async thunk to fetch data

export const fetchEquipments = createAsyncThunk(
    'equipments/fetchEquipments',
    async ({params,token,language}, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/api/Customer/GetAllEquipmentsBystatus', {
                draw: params.draw,
                start: params.start,
                length: params.length,
                search: params.search,  // No need to wrap in an object
                isWeb: params.isWeb,
                customerFk: params.customerFk,
                text: params.text,
                status: params.status,
            },
            {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "lang": language === "English" ? "2" : "1",
                },
              }
        );
            return response.data; // Return data on success
        } catch (error) {
            return rejectWithValue(error.response.data); // Return error on failure
        }
    }
);

// Create the slice
const equipmentsSlice = createSlice({
    name: 'equipments',
    initialState: {
        equipments: {
            message: {
                data: [], // Ensure it's initialized as an array
            },
        },
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEquipments.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchEquipments.fulfilled, (state, action) => {
                state.loading = false;
                state.equipments = action.payload; // Set the equipment data in state
            })
            .addCase(fetchEquipments.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Set error if any
            });
    },
});

export default equipmentsSlice.reducer;
